export type PartnerOverviewMember = {
  contactId: string;
  firstName: string;
  lastName: string;
};

export type PartnerOverviewAdministrator = PartnerOverviewMember & {
  jobTitle: string;
  email: string;
};

export type RoyaltySetupStatus = "notStarted" | "inProgress" | "completed";

export const getRoyaltySetupStatus = (vendorId: unknown): RoyaltySetupStatus => {
  if (typeof vendorId !== "string" || !vendorId.trim()) {
    return "notStarted";
  }
  return vendorId.toLowerCase().includes("pending") ? "inProgress" : "completed";
};

export type PartnerOverviewResponse = {
  people: {
    total: number;
    members: PartnerOverviewMember[];
    administrators: PartnerOverviewAdministrator[];
  };
  royalty?: {
    status: RoyaltySetupStatus;
    vendorId?: string;
    primaryContactEmail?: string;
  };
};
